// Texty sdílených primitiv info stránek (infoPage.js) — výchozí hodnoty pro
// volající, kteří vlastní `alt`/`playLabel` nepošlou.
export default {
  galleryAlt: 'Fotografie prodejny',
  playVideo: 'Přehrát video',
  openMap: 'Otevřít v mapách',
};
